import React, {PropTypes as T} from 'react';

const UnlockIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Unlock Icon"
    viewBox="0 0 21 28"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__unlock ${className}`}>
    <path d="M19.583 26.05a.503.503 0 0 1-.501.504H1.793a.503.503 0 0 1-.501-.504V10.977c0-.278.225
      -.504.501-.504h17.289c.276 0 .501.226.501.504V26.05zm-.501-16.875H6.552V4.823a3.115 3.115 0 0
      1 3.103-3.12h1.554a3.126 3.126 0 0 1 3.115 3.13v.978c0 .357.29.649.645.649a.649.649 0 0 0
      .647-.65v-.977c0-2.44-1.977-4.427-4.407-4.427H9.655C7.231.406 5.26 2.387 5.26 4.823v4.352
      H1.793A1.8 1.8 0 0 0 0 10.977V26.05a1.8 1.8 0 0 0 1.793 1.802h17.289a1.8 1.8 0 0 0 1.793-1.802
      V10.977a1.8 1.8 0 0 0-1.793-1.802z M14.269 18.984c-.265 1.61-1.57 2.92-3.171 3.186a3.855 3.855
      0 0 1-3.407-1.09 3.902 3.902 0 0 1-1.085-3.424c.265-1.61 1.569-2.92 3.17-3.186a3.849 3.849 0 0
      1 3.408 1.09 3.9 3.9 0 0 1 1.085 3.424M11.11 13.16a5.158 5.158 0 0 0-4.333 1.483 5.204 5.204 0
      0 0-1.476 4.354c.292 2.305 2.167 4.19 4.46 4.484.223.028.45.043.674.043a5.134 5.134 0 0 0 3.661
      -1.526 5.203 5.203 0 0 0 1.476-4.355c-.292-2.304-2.169-4.19-4.462-4.483" />
  </svg>
);

UnlockIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  UnlockIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_unlock.js